import type { RequestMessageRequest, ResponseMessageRequest } from "@/types/chat";
import { authService } from "./auth";

const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}persona/`;

export interface GetPersonasResponse {
  personas: {
    aware: Persona[];
    unaware: Persona[];
  };
  count: number;
}

interface Persona {
  id: string;
  name: string;
}

export const getPersonas = async (): Promise<GetPersonasResponse> => {
  try {
    // Ottieni il token ID per l'autenticazione
    const idToken = await authService.getIdToken();
    
    if (!idToken) {
      throw new Error('Authentication token not available');
    }

    // Effettua la chiamata API
    const response = await fetch(API_BASE_URL, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log('data', data.personas, !Array.isArray(data.personas.aware), !Array.isArray(data.personas.notAware));
    // Handle the new data structure
    if (data.personas && typeof data.personas === 'object') {
      return data;
    } else {
      throw new Error('Invalid data format from API');
    }
  } catch (error) {
    console.error('Error fetching personas:', error);
    
    // In case of error, fallback to mock data for development
    if (process.env.NODE_ENV === 'development') {
      console.warn('Using mock data as fallback');
      return mockPersonas;
    }
    
    throw error;
  }
};



export const sendMessagge = async (request: RequestMessageRequest): Promise<ResponseMessageRequest> => {
  try {
    // Get the ID token for authentication
    const idToken = await authService.getIdToken();
    
    if (!idToken) {
      throw new Error('Authentication token not available');
    }

    // Effettua la chiamata API
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });


    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    // Handle the new data structure
    if (data.assistant) {
      return data as ResponseMessageRequest;
    } else {
      throw new Error('Invalid data format from API');
    }
  } catch (error) {
    console.error('Error fetching personas:', error);
    
    // In case of error, fallback to mock data for development
    if (process.env.NODE_ENV === 'development') {
      console.warn('Using mock data as fallback');
      return mockResponseMessageRequest;
    }
    
    throw error;
  }
};

// Keep mock data for development and fallback
const mockPersonas: GetPersonasResponse = {
  personas: {
    aware: [
      { id: "Francesco", name: "Francesco" },
      { id: "Maria", name: "Maria" },
      { id: "Giuseppe", name: "Giuseppe" },
      { id: "Anna", name: "Anna" },
      { id: "Marco", name: "Marco" }
    ],
    unaware: [
      { id: "Mario", name: "Mario" },
      { id: "Luigi", name: "Luigi" },
      { id: "Giovanna", name: "Giovanna" }
    ]
  },
  count: 8,
};


const mockResponseMessageRequest: ResponseMessageRequest = {
  assistant: "Hello! How can I help you?",
};